export enum ETINType {
  SSN = "ssn",
  EIN = "ein",
}
